

















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Spacer from '../shared/Spacer.vue';

const galleryContext = require.context(
  '../../assets/images/choral-conducting-academy/gallery/',
  false,
  /\.jpg$/,
);

@Component({
  components: { Spacer },
})
export default class ChoralConductingAcademy extends Vue {
  public galleryImages: string[] = galleryContext
    .keys()
    .sort()
    .map((key: string) => galleryContext(key));
}
